import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const Select = ({ options, className, defaultOptionLabel, ...rest }) => {
  const optionDoms = options.map(o => (<option key={o.value} value={o.value}>{o.name}</option>));
  if (defaultOptionLabel !== '') {
    optionDoms.unshift((<option key="init_option" value="">{defaultOptionLabel}</option>));
  }
  return (
    <label htmlFor="pcSelect" className={`${styles['select-group']} ${className}`}>
      <select id="pcSelect" className={styles.select} {...rest} >
        {optionDoms}
      </select>
    </label>
  );
};

Select.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  defaultOptionLabel: PropTypes.string,
  value: PropTypes.string,
};

Select.defaultProps = {
  className: '',
  defaultOptionLabel: '',
  value: '',
};

export default Select;
